export function roundDown(number: number, decimals: number): number {
    const multiplier = 10 ** decimals;
    return Math.floor(number * multiplier) / multiplier;
}

export const asymptoticScale = (input: number, min: number, max: number, rate = 1): number =>
    min + (max - min) * (1 - Math.exp(-rate * input));
